React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')

module.exports = class extends React.Component
  displayName: 'SlackRestrictionsComponent'

  render: t.renderable ->
    { isAdmin, hasBC, slackAssociation } = @props

    t.div '.setting-item-detail', ->
      t.div ->
        t.p ->
          if slackAssociation?.adminOnly
            t.format 'slack-admin-only-linking'
          else
            t.format 'slack-normal-member-linking'

      if hasBC && !isAdmin
        t.p '.helper.u-float-left', ->
          t.format 'you-need-to-be-an-admin-to-change-this-setting'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/slack-restrictions-component.coffee